import { useMutation, UseMutationResult } from "react-query";
import type { UseCustomMutationOptions } from "ui/query/react-query-overrides";
import { giftcardsApi } from "../api/giftcardsApi";

export interface UseLoadGiftCardsProps {
    payload: FormData;
}

export default function useLoadGiftCards({
    ...options
}: UseCustomMutationOptions<void, unknown, UseLoadGiftCardsProps>): UseMutationResult<
    void,
    unknown,
    UseLoadGiftCardsProps
> {
    return useMutation(
        async ({ payload }: UseLoadGiftCardsProps) => {
            await giftcardsApi.loadGiftCards(payload);
        },
        { ...options },
    );
}
